import { render, staticRenderFns } from "./CountdownModal.vue?vue&type=template&id=094656e0&"
import script from "./CountdownModal.vue?vue&type=script&lang=js&"
export * from "./CountdownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports